import { Branding } from '../Branding';
import jevLogo from '../../assets/Logo_JEVLangues.svg';

export const jevBranding: Branding = {
  name: 'JEV',
  logo: jevLogo,
  orgEmail: 'jev@email.com',
  orgPhone: '+jev phone',
  privacyPolicyUrl: 'https://www.jev-langues.com/politique-confidentialite/',
  defaultLocale: 'fr',
  withPayment: true,
  paymentProvider: 'verifone',
};
